/* import __COLOCATED_TEMPLATE__ from './rollover-date-picker.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _flatPickerInstance;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import flatpickr from 'flatpickr';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { later, next } from '@ember/runloop';
import { isTesting } from '@embroider/macros';
import { DateTime } from 'luxon';
let CourseRolloverDatePickerComponent = (_class = (_flatPickerInstance = /*#__PURE__*/new WeakMap(), class CourseRolloverDatePickerComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "isOpen", _descriptor2, this);
    _classPrivateFieldInitSpec(this, _flatPickerInstance, void 0);
    _defineProperty(this, "showPicker", _buildTask(() => ({
      context: this,
      generator: function* (element, [course, value]) {
        if (!course) {
          return;
        }
        if (_classPrivateFieldGet(_flatPickerInstance, this)) {
          _classPrivateFieldGet(_flatPickerInstance, this).destroy();
        }
        const currentLocale = this.intl.primaryLocale;
        const courseDT = DateTime.fromJSDate(course.startDate);
        let locale;
        switch (currentLocale) {
          case 'fr':
            // eslint-disable-next-line no-case-declarations
            const {
              French
            } = yield import('flatpickr/dist/l10n/fr.js');
            locale = French;
            break;
          case 'es':
            // eslint-disable-next-line no-case-declarations
            const {
              Spanish
            } = yield import('flatpickr/dist/l10n/es.js');
            locale = Spanish;
            break;
          default:
            locale = 'en';
        }
        _classPrivateFieldSet(_flatPickerInstance, this, flatpickr(element, {
          locale,
          defaultDate: value ?? course.startDate,
          formatDate: dateObj => this.intl.formatDate(dateObj),
          minDate: course.startDate,
          onChange: ([selectedDate]) => this.onChange(selectedDate),
          onOpen: () => {
            // eslint-disable-next-line ember/no-runloop
            later(() => {
              this.isOpen = true;
            }, 250);
          },
          onClose: () => {
            this.isOpen = false;
          },
          disable: [function (date) {
            return DateTime.fromJSDate(date).weekday !== courseDT.weekday;
          }],
          disableMobile: isTesting()
        }));
      }
    }), null, "showPicker", "drop"));
  }
  close() {
    if (_classPrivateFieldGet(_flatPickerInstance, this)) {
      _classPrivateFieldGet(_flatPickerInstance, this).close();
    }
  }
  willDestroy() {
    super.willDestroy(...arguments);
    if (_classPrivateFieldGet(_flatPickerInstance, this)) {
      _classPrivateFieldGet(_flatPickerInstance, this).destroy();
    }
  }
  async onChange(date) {
    // if a date is forced that isn't allowed
    if (!date) {
      date = this.args.course.startDate;
    }
    await this.args.onChange(date);
    // eslint-disable-next-line ember/no-runloop
    await next(() => {});
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _class);
export { CourseRolloverDatePickerComponent as default };